import { RouteConfig } from 'vue-router';
import { VueConstructor } from 'vue';

import ProductDetails from '../components/entities/products/ProductDetails.vue';
import ProductTable from '../components/entities/products/ProductsTable.vue';
import PreorderProductsTable from '@/components/entities/preorderProducts/PreorderProductsTable.vue';
import PreorderProductDialog from '@/components/entities/preorderProducts/PreorderProductDialog.vue';
import ColorsTable from '@/components/entities/colors/ColorsTable.vue';
import ColorsDialog from '@/components/entities/colors/ColorsDialog.vue';
import CategoriesTable from '@/components/entities/categories/CategoriesTable.vue';
import CategoriesDialog from '@/components/entities/categories/CategoryDetails.vue';
import QuantityBreakTable from '@/components/entities/quantityBreaks/QuantityBreaksTable.vue';
import QuantityBreakDialog from '@/components/entities/quantityBreaks/QuantityBreaksDialog.vue';
import ColorGroupsTable from '@/components/entities/colorGroups/ColorGroupsTable.vue';
import ColorGroupDetails from '@/components/entities/colorGroups/ColorGroupsDialog.vue';
import NewCategoryDialog from '@/components/entities/categories/NewCategoryDialog.vue';
import ProductCategoryOptionsDialog from '@/components/entities/productCategoryOptions&Attributes/ProductCategoryOptionsDialog.vue';
import ProductCategoryAttributesDialog from '@/components/entities/productCategoryOptions&Attributes/ProductCategoryAttributesDialog.vue';
import NewProductDialog from '@/components/entities/products/NewProductDialog.vue';
import ProductionTimeTable from '@/components/entities/productionTimes/ProductionTimeTable.vue';
import ProductionTimeDialog from '@/components/entities/productionTimes/ProductionTimeDialog.vue';
import OptionsTable from '@/components/entities/productCategoryOptions&Attributes/OptionsTable.vue';
import AttributesTable from '@/components/entities/productCategoryOptions&Attributes/AttributesTable.vue';
import UnauthorizedPage from '@/components/main/UnauthorizedPage.vue';
import FontsTable from '@/components/entities/fonts/FontsTable.vue';
import FontGroupsTable from '@/components/entities/fontGroups/FontGroupsTable.vue';
import FontGroupDetail from '@/components/entities/fontGroups/FontGroupsDialog.vue';

const routes: RouteConfig[] = [
  {
    path: '/categories',
    component: CategoriesTable as VueConstructor,
    name: 'Categories',
    meta: {
      title: 'Product Categories',
      icon: 'mdi-group',
    },
    children: [
      {
        path: 'new',
        components: {
          default: CategoriesTable as VueConstructor,
          editDialog: NewCategoryDialog as VueConstructor,
        },
        meta: {
          title: 'New category',
        },
      },
      {
        path: ':id',
        components: {
          default: CategoriesTable as VueConstructor,
          editDialog: CategoriesDialog as VueConstructor,
        },
        meta: {
          title: 'Category',
        },
        props: { default: false, editDialog: true },
      },
    ],
  },
  {
    path: '/products',
    component: ProductTable as VueConstructor,
    props: { useCustomURL: false },
    name: 'Products',
    meta: {
      title: 'Products',
      icon: 'mdi-tag',
    },
    children: [
      {
        path: 'new',
        components: {
          default: ProductTable as VueConstructor,
          editDialog: NewProductDialog as VueConstructor,
        },
        meta: {
          title: 'New products',
        },
      },
      {
        path: ':id',
        components: {
          default: ProductTable as VueConstructor,
          editDialog: ProductDetails as VueConstructor,
        },
        meta: {
          title: 'Product',
        },
        props: { default: false, editDialog: true },
      },
    ],
  },
  {
    path: '/preorderproducts',
    component: PreorderProductsTable as VueConstructor,
    props: { useCustomURL: false },
    name: 'Preorder Products',
    meta: {
      title: 'Preorder Products',
      icon: 'mdi-cart',
    },
    children: [
      {
        path: ':id',
        components: {
          default: PreorderProductsTable as VueConstructor,
          editDialog: PreorderProductDialog as VueConstructor,
        },
        meta: {
          title: 'Preorder Product',
        },
        props: { default: false, editDialog: true },
      },
    ],
  },
  {
    path: `/colors`,
    component: ColorsTable as VueConstructor,
    name: 'Colors',
    meta: {
      title: 'Colors',
      icon: 'mdi-format-color-fill',
    },
    children: [
      {
        path: 'new',
        components: {
          default: ColorsTable as VueConstructor,
          editDialog: ColorsDialog as VueConstructor,
        },
        meta: {
          title: 'New color',
        },
      },
      {
        path: ':id',
        components: {
          default: ColorsTable as VueConstructor,
          editDialog: ColorsDialog as VueConstructor,
        },
        meta: {
          title: 'Color',
        },
        props: { default: false, editDialog: true },
      },
    ],
  },
  {
    path: '/colorgroups',
    component: ColorGroupsTable as VueConstructor,
    name: 'Color Groups',
    meta: {
      title: 'Color Groups',
      icon: 'mdi-palette',
    },
    children: [
      {
        path: 'new',
        components: {
          default: ColorGroupsTable as VueConstructor,
          editDialog: ColorGroupDetails as VueConstructor,
        },
        meta: {
          title: 'New color group',
        },
      },
      {
        path: ':id',
        components: {
          default: ColorGroupsTable as VueConstructor,
          editDialog: ColorGroupDetails as VueConstructor,
        },
        meta: {
          title: 'Color Group',
        },
        props: { default: false, editDialog: true },
      },
    ],
  },
  {
    path: `/fonts`,
    component: FontsTable as VueConstructor,
    name: 'Fonts',
    meta: {
      title: 'Fonts',
      icon: 'mdi-format-font',
    },
  },
  {
    path: `/fontgroups`,
    component: FontGroupsTable as VueConstructor,
    name: 'Font Groups',
    meta: {
      title: 'Font Groups',
      icon: 'mdi-format-font',
    },
    children: [
      {
        path: 'new',
        components: {
          default: FontGroupsTable as VueConstructor,
          editDialog: FontGroupDetail as VueConstructor,
        },
        meta: {
          title: 'New font group',
        },
      },
      {
        path: ':id',
        components: {
          default: FontGroupsTable as VueConstructor,
          editDialog: FontGroupDetail as VueConstructor,
        },
        meta: {
          title: 'Font Group',
        },
        props: { default: false, editDialog: true },
      },
    ],
  },
  {
    path: '/quantitybreaks',
    component: QuantityBreakTable as VueConstructor,
    children: [
      {
        path: 'new',
        components: {
          default: QuantityBreakTable as VueConstructor,
          editDialog: QuantityBreakDialog as VueConstructor,
        },
        meta: {
          title: 'New quantity break',
        },
      },
      {
        path: ':id',
        components: {
          default: QuantityBreakTable as VueConstructor,
          editDialog: QuantityBreakDialog as VueConstructor,
        },
        meta: {
          title: 'Quantity Break',
        },
        props: { default: false, editDialog: true },
      },
    ],
    name: 'QuantityBreaks',
    meta: {
      title: 'Quantity Breaks',
      icon: 'mdi-chart-timeline',
    },
  },
  {
    path: '/productiontimes',
    component: ProductionTimeTable as VueConstructor,
    children: [
      {
        path: 'new',
        components: {
          default: ProductionTimeTable as VueConstructor,
          editDialog: ProductionTimeDialog as VueConstructor,
        },
        meta: {
          title: 'New Production Time',
        },
      },
      {
        path: ':id',
        components: {
          default: ProductionTimeTable as VueConstructor,
          editDialog: ProductionTimeDialog as VueConstructor,
        },
        meta: {
          title: 'Production Time',
        },
        props: { default: false, editDialog: true },
      },
    ],
    name: 'ProductionTime',
    meta: {
      title: 'Production Time',
      icon: 'mdi-timetable',
    },
  },
  {
    path: '/options',
    component: OptionsTable as VueConstructor,
    children: [
      {
        path: 'new',
        components: {
          default: OptionsTable as VueConstructor,
          editDialog: ProductCategoryOptionsDialog as VueConstructor,
        },
        meta: {
          title: 'New Product Category Option',
        },
      },
      {
        path: ':id',
        components: {
          default: OptionsTable as VueConstructor,
          editDialog: ProductCategoryOptionsDialog as VueConstructor,
        },
        meta: {
          title: 'Product Category Option',
        },
        props: { default: false, editDialog: true },
      },
    ],
    name: 'Options&Attributes',
    meta: {
      title: 'Options and Attributes',
      icon: 'mdi-order-bool-ascending-variant',
    },
  },
  {
    path: '/attributes',
    component: AttributesTable as VueConstructor,
    children: [
      {
        path: 'new',
        components: {
          default: AttributesTable as VueConstructor,
          editDialog: ProductCategoryAttributesDialog as VueConstructor,
        },
        meta: {
          title: 'New Product Category Attribute',
        },
      },
      {
        path: ':id',
        components: {
          default: AttributesTable as VueConstructor,
          editDialog: ProductCategoryAttributesDialog as VueConstructor,
        },
        meta: {
          title: 'Product Category Attribute',
        },
        props: { default: false, editDialog: true },
      },
    ],
    name: 'Options&Attributes',
    meta: {
      title: 'Options and Attributes',
      icon: 'mdi-order-bool-ascending-variant',
      isSidebarItem: false,
    },
  },
  {
    path: '/unauthorized',
    component: UnauthorizedPage as VueConstructor,
    name: 'Unauthorized',
    meta: {
      title: 'NAVBAR',
      isSidebarItem: false,
    },
  },
];

export default routes;
